/**
 * CategoryBanner — shared banner rendered on category pages.
 * Guarantees readable text over ANY background image thanks to:
 *  - Dark gradient overlay layer (from top rgba(0,0,0,0.1) → bottom rgba(0,0,0,0.7))
 *  - Forced white text color for title + description
 *  - Text-shadow for extra contrast on lighter/busier images
 * Stacking (bottom → top): image → gradient overlay → text content.
 */
export default function CategoryBanner({ imageUrl, kicker = "Catégorie", title, description }) {
  return (
    <div
      className="relative rounded-3xl overflow-hidden mb-10"
      data-testid="category-banner"
    >
      {/* Layer 1 — background image (fills the banner) */}
      <img
        src={imageUrl}
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        style={{ zIndex: 0 }}
        data-testid="category-banner-image"
      />

      {/* Layer 2 — dark gradient overlay ensures text readability on any image */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          zIndex: 1,
          background:
            "linear-gradient(to bottom, rgba(0,0,0,0.10) 0%, rgba(0,0,0,0.70) 100%)",
        }}
        data-testid="category-banner-overlay"
      />

      {/* Layer 3 — text content, forced white + text-shadow */}
      <div
        className="relative px-8 py-16 md:py-24"
        style={{ zIndex: 2 }}
      >
        <div
          className="text-xs uppercase tracking-widest font-mono mb-3"
          style={{ color: "#FFFFFF", textShadow: "0 2px 4px rgba(0,0,0,0.6)" }}
          data-testid="category-banner-kicker"
        >
          {kicker}
        </div>
        <h1
          className="font-display text-4xl md:text-6xl font-bold"
          style={{ color: "#FFFFFF", textShadow: "0 2px 4px rgba(0,0,0,0.6)" }}
          data-testid="category-banner-title"
        >
          {title}
        </h1>
        {description && (
          <p
            className="mt-4 max-w-3xl text-lg leading-relaxed"
            style={{ color: "#FFFFFF", textShadow: "0 2px 4px rgba(0,0,0,0.6)" }}
            data-testid="category-banner-description"
          >
            {description}
          </p>
        )}
      </div>
    </div>
  );
}
